import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import BronzePass from '../../assets/bronze_pass_card.png';
import GoldPass from '../../assets/gold_pass_card.png';
import Arrow from '../../assets/icons/arrow.svg';
import SilverPass from '../../assets/silver_pass_card.png';
import { TOURNAMENT_DISABLED_SITES } from '../../constants';
import { StepKeyName } from '../../types';

import StepOnDemand from './StepOnDemand';
import StepScheduled from './StepScheduled';
import {
  TXTCLI_BRONZE_POWER_PASS,
  TXTCLI_GOLD_POWER_PASS,
  TXTCLI_OR,
  TXTCLI_SILVER_POWER_PASS
} from './Steps.messages.json';
import styles from './Steps.scss';

const passes = [
  {
    key: 'GoldPass',
    src: GoldPass,
    className: styles.passesGold,
    alt: TXTCLI_GOLD_POWER_PASS
  },
  {
    key: 'SilverPass',
    src: SilverPass,
    className: styles.passesSilver,
    alt: TXTCLI_SILVER_POWER_PASS
  },
  {
    key: 'BronzePass',
    src: BronzePass,
    className: styles.passesBronze,
    alt: TXTCLI_BRONZE_POWER_PASS
  }
];

const Steps = () => {
  const { formatMessage } = useIntl();
  const site = useSelector(select.cms.getSiteId);
  const isTournamentDisabled = TOURNAMENT_DISABLED_SITES.includes(site);

  return (
    <div
      className={classNames(styles.tileContainer, {
        [styles.tournamentDisabled]: isTournamentDisabled
      })}
    >
      <div className={styles.tileWrapper}>
        <StepOnDemand stepKey={StepKeyName.step1} bannerClassName={styles.bannerStep1} />
        <Arrow className={classNames(styles.arrow, styles.arrowStep1)} />
      </div>
      <div className={classNames(styles.tileWrapper, styles.tileGroup)}>
        <div className={styles.stepContainer}>
          <StepScheduled stepKey={StepKeyName.step2SNG} bannerClassName={styles.bannerStep2} />
        </div>
        {!isTournamentDisabled && (
          <>
            <div className={styles.stepSeperator}>
              <Translation {...TXTCLI_OR} />
            </div>
            <div className={styles.stepContainer}>
              <StepScheduled
                stepKey={StepKeyName.step2Scheduled}
                bannerClassName={styles.bannerStep2}
              />
            </div>
          </>
        )}
        <Arrow className={classNames(styles.arrow, styles.arrowStep2)} />
      </div>
      <div className={styles.tileWrapper}>
        <StepScheduled stepKey={StepKeyName.step3} bannerClassName={styles.bannerStep3} />
        <Arrow className={classNames(styles.arrow, styles.arrowStep3)} />
      </div>
      <div className={styles.tileWrapper}>
        <StepScheduled stepKey={StepKeyName.step4} bannerClassName={styles.bannerStep4} />
        {passes.map(({ className, alt, src, key }) => (
          <img
            key={key}
            className={classNames(styles.passesItem, className)}
            src={src}
            alt={formatMessage(alt)}
          />
        ))}
      </div>
    </div>
  );
};
export default Steps;
